$(document).ready(function(){
	
    $('ul.ctm_tab .ctm_tab_li').click(function(){
        var tab_id = $(this).attr('ctm-data-tab');
    
        $('ul.ctm_tab .ctm_tab_li').removeClass('current');
        $('.ctm-tab-content').removeClass('current');
    
        $(this).addClass('current');
        $("#"+tab_id).addClass('current');
    })
    
    })